import React from 'react';
import ImageFadeIn from 'react-image-fade-in';
import { Users, ArrowLeft } from 'react-feather';
import styles from '../Writes.module.scss';
import { useQuery } from '@apollo/react-hooks';
import { BOOK_TEMPLATE_CATEGORY } from '../services/graphql';
import { useNavigate } from '@reach/router';

const SelectWriteCategory = ({
    navigateBack,
    selectedClass,
    selectedGroup,
    selectedCategory,
    setSelectedCategory,
    setSelectedSubCategory,
}) => {
    const navigate = useNavigate();
    const { data, loading, error } = useQuery(BOOK_TEMPLATE_CATEGORY);

    if (error) {
        return <p>Page data could not be loaded.</p>;
    }

    if (loading) {
        return <p> Loading </p>;
    }

    return (
        <>
            <div className='page-header'>
                <div className='page-header__content'>
                    <div className='page-header__content__inner'>
                        <h2 className='page-header__content__title'>
                            <Users />
                            {selectedClass
                                ? selectedClass.name
                                : selectedGroup.name}
                        </h2>
                    </div>
                </div>
                <div className='page-header__actions'>
                    <button
                        onClick={navigateBack}
                        className='btn-reset u-display-flex u-align-center u-text-dark'
                    >
                        <ArrowLeft className='u-m-right-1' /> Back
                    </button>
                </div>
            </div>
            <h1 className={styles.categoriesSubcategoriesTitle}>
                Choose a category
            </h1>
            <div className={styles.writeCategoriesWrapper}>
                {data.bookTemplateCategories.map((writeCategory) => {
                    return (
                        <div
                            key={writeCategory.id}
                            style={{
                                backgroundColor: writeCategory.backgroundColor || '#000',
                                opacity: selectedCategory
                                    ? writeCategory.id === selectedCategory.id
                                        ? '1'
                                        : '40%'
                                    : '1',
                            }}
                            className={styles.writeCategoryCard}
                            onClick={() => setSelectedCategory(writeCategory)}
                        >
                            <ImageFadeIn
                                width={120}
                                src={
                                    writeCategory.iconUrl
                                        ? writeCategory.iconUrl
                                        : ''
                                }
                                alt='category-image'
                            />
                            <h1
                                style={{
                                    color: writeCategory.textColor || '#fff',
                                }}
                            >
                                {writeCategory.name}
                            </h1>
                            <h3
                                style={{
                                    color: writeCategory.textColor
                                        ? writeCategory.textColor
                                        : '',
                                }}
                            >
                                {writeCategory.description}
                            </h3>
                        </div>
                    );
                })}
            </div>

            {selectedCategory ? (
                selectedCategory.subcategories &&
                selectedCategory.subcategories.length ? (
                    <>
                        <div
                            className={
                                styles.writeSubcategoriesTitleContentContainer
                            }
                        >
                            <h1 className={styles.categoriesSubcategoriesTitle}>
                                Choose a subcategory
                            </h1>
                            <div className={styles.writeSubcategoriesWrapper}>
                                {selectedCategory.subcategories.map(
                                    (writeSubcategory) => {
                                        return (
                                            <div
                                                key={
                                                    writeSubcategory.description +
                                                    writeSubcategory.name
                                                }
                                                className={
                                                    styles.writeSubcategoryCard
                                                }
                                                style={{
                                                    backgroundColor:
                                                        writeSubcategory.backgroundColor || '#000',
                                                }}
                                                onClick={() => {
                                                    navigate(
                                                        `/startWrite/configureWriteChaptersIsp/${
                                                            selectedClass
                                                                ? selectedClass.id
                                                                : selectedGroup.id
                                                        }`
                                                    );
                                                    setSelectedSubCategory(
                                                        writeSubcategory
                                                    );
                                                }}
                                            >
                                                <ImageFadeIn
                                                    width={120}
                                                    src={
                                                        writeSubcategory.iconUrl
                                                            ? writeSubcategory.iconUrl
                                                            : ''
                                                    }
                                                    alt='subcategory-image'
                                                />
                                                <div>
                                                    <h1
                                                        style={{
                                                            color: writeSubcategory.textColor
                                                                ? writeSubcategory.textColor
                                                                : '',
                                                        }}
                                                    >
                                                        {writeSubcategory.name}
                                                    </h1>
                                                    <h3
                                                        style={{
                                                            color: writeSubcategory.textColor || '#fff',
                                                        }}
                                                    >
                                                        {
                                                            writeSubcategory.description
                                                        }
                                                    </h3>
                                                </div>
                                            </div>
                                        );
                                    }
                                )}
                            </div>
                        </div>
                    </>
                ) : (
                    <p>The selected category has no subcategories</p>
                )
            ) : (
                ''
            )}
        </>
    );
};

export default SelectWriteCategory;
